import { CartItemFragment } from '@graphcommerce/magento-cart-items'

export const gtagAddToCart = (addedItem: CartItemFragment, quantity: number, opts?: { added_from?: string }) => {
  if (addedItem && addedItem.prices && addedItem.prices.row_total_including_tax.value) {
    // we need to manually calculate pricePerItemInclTax (https://github.com/magento/magento2/issues/33848)
    const pricePerItemInclTax = addedItem.prices.row_total_including_tax.value / addedItem.quantity
    const addToCartValue = pricePerItemInclTax * addedItem.quantity

    globalThis.gtag?.('event', 'add_to_cart', {
      currency: addedItem?.prices?.price.currency,
      value: addToCartValue,
      items: [
        {
          item_id: addedItem?.product.sku,
          item_name: addedItem?.product.name,
          currency: addedItem?.prices?.price.currency,
          price: addToCartValue,
          quantity,
          discount: addedItem?.prices?.discounts?.reduce(
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            (sum, discount) => sum + (discount?.amount?.value ?? 0),
            0,
          ),
          added_from: opts?.added_from,
        },
      ],
    })
  }
}
